'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dekuRedux = require('@viskan/deku-redux');

var _image = require('./components/image');

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fallbackMediaConfig = function fallbackMediaConfig(state) {
	var mediaDir = state.site.media_dir;
	var mediaPath = mediaDir.endsWith('/') ? mediaDir.substring(0, mediaDir.length - 1) : mediaDir;
	return { mediaPath: mediaPath };
};

exports.default = (0, _dekuRedux.connect)(function (state) {
	return { mediaConfig: state.site.mediaConfig || fallbackMediaConfig(state) };
})(_image2.default);